<template>
  <div class="order-detail">
    <nav-bar :bgc="'background:#fff'" :isFixed="true" :title="$t('下單')"></nav-bar>
    <div :class="['order-content',{ headerTop: !isWeiXin() }]">
      <div class="adderss" @click="handleAddress" v-if="orderData.addresses?.length === 0">
        <img src="@/assets/icons/general@2x.png" alt="" />
        {{ $t("添加地址") }}
      </div>
      <div class="adderss" v-else>
        <div class="address-detail" @click="handleAddress">
          <div class="address-content">
            <div class="top">
              <div class="address-name">{{ defaultAddresses.name }}</div>
              <div class="address-phone">{{ defaultAddresses.phone }}</div>
            </div>
            <div>
              <div class="address-street">
                {{ defaultAddresses.address }}
              </div>
            </div>
            <div class="address-city">
              {{ spliceAddress(defaultAddresses.province) }}
              {{ spliceAddress(defaultAddresses.city) }}
              {{ spliceAddress(defaultAddresses.district) }}
              {{ defaultAddresses.street }}
            </div>
          </div>
          <img class="arrow" src="@/assets/icons/arrow-right.png" alt="" />
        </div>
      </div>
      <div class="pay-type">
        <div class="pay-title">{{ $t("付款方式") }}</div>
        <div class="phone-list">
          <div v-for="item in columns" :key="item.value" @click="handleAreaCode(item)">
            <div :class="['phone-item',{ actvie: item.value == selectPhone }]">
              <div class="phone-text">{{ item.label }}</div>
              <img class="phone-check" v-if="item.value == selectPhone" src="@/assets/icons/check.png" alt="" />
            </div>
            <div v-if="selectPhone == item.value && selectPhone !== '0'" class="phone-tip">
              <div class="phone-title">{{ item.tip }}</div>
              <div class="richText" v-html="item.text"></div>
              <div class="copy-writing" @click="copyInformation(item.text)">
                <img src="@/assets/icons/copy.png" alt="" class="copywritingimg" />
                {{ $t("複製賬戶信息") }}
              </div>
            </div>
          </div>
          <!-- <div v-if="!orderData.canUseCheck">
            <div class="phone-item">
              <div :class="[{ 'disable-text': !orderData.canUseCheck }]">{{ orderData.paymentSet.chequeName }}</div>
            </div>
            <div class="tigs-red">{{ $t("您有一張未結清的支票訂單，轉帳後可以繼續使用支票付款") }}</div>
          </div> -->
        </div>
      </div>
      <div class="Stash">
        <div class="goods-list" v-for="(item,index) in orderData.splitOrders" :key="index">
          <div class="Stash-title">
            {{ item.storeName }}
          </div>
          <div class="goods-item" v-for="(goods,idx) in item.orderTemps.slice(0,orderIndex)" :key="idx">
            <div class="goods-img">
              <img :src="getProductImageUrl(goods.picturePath,400)" alt="" />
              <div class="tags" v-if="goods.tag">{{ goods.tag }}</div>
            </div>
            <div class="goods-info">
              <div class="goods-name">
                {{ goods.name }}
              </div>
              <div class="goods-tag" v-if="goods.mainTag">{{ goods.mainTag }}</div>
              <div class="goods-unit">{{ goods.standard }}</div>
              <div class="goods-price">
                <!-- <div class="price">{{ formatNumber(goods.unitPrice) }}</div> -->
                <div class="price">{{ formatNumber(goods.displayunitPrice) }}</div>
                <div class="count">{{ $t("數量") }}{{ goods.amount }}</div>
              </div>
            </div>
          </div>
          <div class="viewall" @click="getViewallGoods('1')" v-if="item.orderTemps.length > 3 && unfold">
            {{ $t("查看所有") }} {{ item.orderTemps.length }}
            {{ $t("個商品") }}
            <img src="@/assets/icons/direction@2x.png" alt="" />
          </div>
          <div class="viewall" @click="getViewallGoods('2')" v-if="!unfold">
            {{ $t("收起") }}
            <img src="@/assets/icons/unfold.png" alt="" />
          </div>
          <div>
            <div class="Distribution-mode">
              <div class="Distribution-item">
                <div class="label">{{ $t("配送方式") }}</div>
                <div>{{ getFreight(item.expressPrice)?.expressName }}</div>
              </div>
              <div class="Distribution-item">
                <div class="label">{{ $t("運費") }}</div>
                <div class="freight">
                  {{
                    formatNumber(
                      orderData.displaytotalPrice > getFreight(item.expressPrice)?.freePrice ?
                      0 :
                      getFreight(item.expressPrice)?.freight
                    )
                  }}
                </div>
              </div>
              <!-- 只有在有药品商品时才显示上传药品单按钮 -->
              <div class="Distribution-item" v-if="item.isYp">
                <div class="label">{{ $t("上傳蓋章藥品單") }}</div>
                <div style="display: flex; align-items: center;">
                  <span 
                    @click="handleUploadDrug(index)" 
                    :class="{
                      'upload-btn': true,
                      'upload-red': item.ypCheckStatus === 3
                    }"
                  >
                    {{ getYpButtonText(item.ypCheckStatus) }}
                  </span>
                  <van-icon name="arrow" @click="handleUploadDrug(index)" style="margin-right: 10px;" />
                  <!-- <span class="view-yp-list" @click="goToYpOrderList">{{ $t("藥品單列表") }}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="leaveMessage">
        <div class="leaveMessage-title">{{ $t("給商家留言") }}</div>
        <div class="leaveMessage-inp">
          <input v-model="remark" type="text" :placeholder="$t('請填寫留言内容')" />
        </div>
        <div class="aggregate">
          {{ $t("給商家留言") }}{{ $t("訂單總計 ") }}({{ length
          }}{{ $t("件商品") }})
        </div>
        <div class="aggregate-price">
          <div>{{ $t("產品價格") }}</div>
          <!-- <div>{{ formatNumber(goodsTotal) }}</div> -->
          <div>{{ formatNumber(displaygoodsTotal) }}</div>
        </div>
        <div class="aggregate-price">
          <div>{{ $t("運費總計") }}</div>
          <div>
            {{ formatNumber(freightTotal) }}
          </div>
        </div>
        <div class="aggregate-price">
          <div>{{ $t("優惠券") }}</div>
          <div class="discountsprice" @click="handleSelectCoupon" v-if="couponPrice">
            <!-- -{{ formatNumber(Math.abs(couponPrice)) }} -->
            -{{ formatNumber(Math.abs(couponPrice)) }}
            <img v-if="isHKCustomer" src="@/assets/icons/arrow-right.png" alt="" />

          </div>
          <div v-else class="discountsprice" @click="handleSelectCoupon">
            {{ $t("優惠券選擇") }}
            <img v-if="isHKCustomer" src="@/assets/icons/arrow-right.png" alt="" />
          </div>
        </div>
        <div class="aggregate-price">
          <div>{{ $t("優惠") }}</div>
          <div class="discountsprice">
            -{{ formatNumber(Math.abs(preferential)) }}
          </div>
        </div>
        <div class="aggregate-price">
          <div>{{ $t("需支付总额") }}</div>
          <div class="discountsprice">
            {{ formatNumber(totalPrice) }}
          </div>
        </div>
      </div>
      <div class="order-footer">
        <div class="shop-coudan" v-if="tips && tips.makeUpType == 2 && CoudanObj && CoudanObj?.couponId">
          <div class="shop-coudan-left" v-if="langEnv == 3">
            <div class="tags">滿{{ CoudanObj.metPrice }}減{{ CoudanObj.price }}</div>
            <div class="tigs">滿{{ CoudanObj.metPrice }}減{{ CoudanObj.price }}，還差<span>{{
              formatNumber(CoudanObj.metPrice - goodsTotal) }}</span></div>
          </div>
          <div class="shop-coudan-left" v-else>
            <div class="EnTigs">Purchase to {{ formatNumber(CoudanObj.metPrice) }} free {{
              formatNumber(CoudanObj.price) }},Only<span>{{
                formatNumber(CoudanObj.metPrice - goodsTotal) }}</span></div>
          </div>
          <div class="shop-coudan-right" @click="handlegoHome">{{ $t('去凑单') }} <van-icon name="arrow" /></div>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div class="price">{{ formatNumber(totalPrice) }}</div>
          <div class="Placeorder" @click="getCreateOrder">
            {{ $t("下單") }}
          </div>
        </div>
      </div>
    </div>
    <SelectCountDialog ref="selectCountRef" :list="CanCoupon" :list2="NoCanCoupon" @success="handleSuccess" />
    <!-- 药品提示信息弹窗 -->
    <DrugTipsDialog ref="drugTipsDialogRef" />
    <!-- 盖章药品单上传弹窗 -->
    <UploadDrugDialog ref="uploadDrugDialogRef" @submit="handleDrugUploadSubmit" />
  </div>
</template>

<script>
import { getProductOrderDetail } from "@/api/productdetails.js"
import mixins from "@/utils/mixins.js"
import { mapState } from "vuex"
import { getCreateOrder2, pollOrderStatus } from "@/api/user.js"
import SelectCountDialog from "@/components/SelectCountDialog/index.vue"
import DrugTipsDialog from "@/components/DrugTipsDialog/index.vue"
import UploadDrugDialog from "@/components/UploadDrugDialog/index.vue"
export default {
  mixins: [mixins],
  data () {
    return {
      columns: [],
      orderData: {},
      selectPhone: "0",
      orderIndex: 3,
      freightTotal: 0,
      goodsTotal: 0,
      displaygoodsTotal: 0,
      // 全场优惠
      preferential: 0,
      // 优惠券价格
      couponPrice: 0,
      displayCouponPrice: 0,
      // 优惠价格
      preferentialPrice: 0,
      // 合计
      totalPrice: 0,
      length: 0,
      couponId: null,
      unfold: true,
      defaultAddresses: {},
      remark: "",
      CanCoupon: [],
      NoCanCoupon: [],
      langEnv: null,
      isHKCustomer: false,
      userCoupon: [],
      tips: [],
      CoudanObj: {},
      currentYpOrderIndex: undefined
    }
  },
  components: {
    SelectCountDialog,
    DrugTipsDialog,
    UploadDrugDialog
  },
  computed: {
    ...mapState("user", ["checkAddress"])
  },
  async created () {
    this.isHKCustomer = window.localStorage.getItem("isHKCustomer") === 'true' || false
    await this.getOrderDetail()
    this.getFreightTotal()
    if (this.checkAddress?.id) {
      this.defaultAddresses = this.checkAddress
    } else {
      this.defaultAddresses = this.orderData.addresses.find(
        item => item.isDefault
      ) ? this.orderData.addresses.find(
        item => item.isDefault
      ) : {}
    }
    const data = this.CanCoupon.filter(item => item.couponId === this.orderData?.defaultCoupon)[0]
    // this.couponPrice = data?.price || 0
    if(this.isHKCustomer){
      this.couponPrice = data?.price || 0
    }else{
      this.couponPrice = this.orderData?.displayCouponPrice || 0
    }
    // 总优惠价格
    this.preferentialPrice = this.couponPrice + Math.abs(this.preferential)
    const price = Math.max((this.orderData.totalFinishPrice - this.preferentialPrice), 0)
    this.totalPrice = price + this.freightTotal
    await this.handleGetCoudan()
    this.couponId = data?.couponId || null
    console.log(this.freightTotal)
    console.log(this.preferential)
    this.langEnv = window.localStorage.getItem("langEnv") || 2
    console.log('langEnv',window.localStorage.getItem("langEnv"));
    console.log('langEnv1',this.langEnv);
    console.log('isHKCustomer',window.localStorage.getItem("isHKCustomer"))
  },
  mounted () {
    // 移除进入页面自动检查药品状态的逻辑
  },
  methods: {
    // 根据ypCheckStatus获取按钮文案
    getYpButtonText(status) {
      const statusText = {
        0: this.$t('上傳'),
        1: this.$t('查看'),
        2: this.$t('查看'),
        3: this.$t('待重新上傳')
      };
      return statusText[status] || this.$t('上傳');
    },
    handlegoHome () {
      this.$router.replace("/home")
    },
    // 获取最新的凑单情况
    handleGetCoudan () {
      let arr = this.userCoupon.sort((a, b) => {
        if (b.metPrice != a.metPrice) {
          return a.metPrice - b.metPrice
        } else {
          return b.price - a.price
        }
      })
      this.CoudanObj = arr.find((item) => item.metPrice > this.goodsTotal && item.isAllUse)

    },
    async handleSuccess (row) {
      this.couponPrice = row?.price || 0
      this.couponId = row.couponId || null
      this.preferentialPrice = this.couponPrice + Math.abs(this.preferential)
      const price = Math.max((this.orderData.totalFinishPrice - this.preferentialPrice), 0)
      this.totalPrice = price + this.freightTotal
      await this.handleGetCoudan()
    },
    handleSelectCoupon () {
      if (window.localStorage.getItem("isHKCustomer") === 'false') {
        this.$toast('该地区不允许使用优惠券')
        return
      }
      this.$refs.selectCountRef.show()
    },
    async getCreateOrder () {
      // 先检查药品状态并根据情况显示提示
      this.showYpTipsAndOrder();
    },
    getFreight (list) {
      return list.find(item => item.isDefault)
    },
    spliceAddress (str) {
      const regex = new RegExp(`(?:${"●"})(.*)`)
      const match = (str || "").match(regex)
      return match && match[1] ? match[1] + "," : ""
    },
    handleAddress () {
      this.$router.push(`/user/address?type=1&id=${this.defaultAddresses.id}`)
      if (this.defaultAddresses.id) {
        this.$store.dispatch("user/getEditAddress", this.defaultAddresses.id)

      }
    },
    copyInformation (item) {
      let textToCopy = ""
      const paragraphs = document.querySelectorAll(".richText p")

      // 遍历每个 p 元素
      for (let i = 0; i < paragraphs.length; i++) {
        const paragraph = paragraphs[i]
        // 获取 p 元素内的文本内容
        const textContent = paragraph.textContent.trim()
        // 将文本内容添加到要复制的字符串中
        textToCopy += textContent + "\n" // 添加换行符
      }
      var tempInput = document.createElement("textarea")
      // 设置输入框的值为要复制的文本
      tempInput.value = textToCopy
      // 将输入框添加到页面中
      document.body.appendChild(tempInput)
      // 选中输入框中的文本
      tempInput.select()
      // 执行复制命令
      document.execCommand("copy")
      // 移除临时输入框
      document.body.removeChild(tempInput)
      this.$toast(this.$t("複製成功!"))
    },
    getFreightTotal () {
      this.orderData.splitOrders.forEach(item => {
        this.goodsTotal += item.totalPrice
        this.displaygoodsTotal += item.displaytotalPrice
        item.orderTemps.forEach(v => {
          this.length += v.amount
        })

        item.expressPrice.forEach(i => {
          if (i.isDefault && item.displaytotalPrice < i.freePrice) {
            this.freightTotal += i.freight
          }
        })
      })
      this.preferential = this.orderData.cutList.reduce(
        (prve, next) => prve + next.cutPrice,
        0
      )
    },
    getViewallGoods (type) {
      if (type === "1") {
        this.orderIndex = undefined
        this.unfold = false
      } else {
        this.orderIndex = 3
        this.unfold = true
      }
    },
    handleAreaCode (item) {
      this.selectPhone = item.value
    },
    async getOrderDetail () {
      const res = await getProductOrderDetail()
      if (res.resultID === 1200) {
        this.orderData = res.data;
        // 排序，药品商品排在前面
        this.orderData.splitOrders = this.orderData.splitOrders.sort((a, b) => {
          return a.isYp ? -1 : 1
        })
        
        if (this.columns.length === 0) {
          this.columns.push({
            label: this.orderData.paymentSet.onlineName,
            value: "0",
            text: ""
          })
          this.columns.push({
            label: this.orderData.paymentSet.pubTransferName,
            value: "1",
            tip: this.orderData.paymentSet.pubTransferCopywriting,
            text: this.orderData.paymentSet.pubTransferAccount
          })
        }
        this.CanCoupon = res.data?.coupons.filter(item => item.canUse).map(it => {
          return {
            ...it,
            active: res.data?.defaultCoupon === it.couponId ? true : false
          }
        })
        this.NoCanCoupon = res.data?.coupons.filter(item => !item.canUse)
        this.userCoupon = res.data?.coupons
        this.tips = res.data?.tips
        // if (res.data?.canUseCheck) {
        //   this.columns.push({
        //     label: this.orderData.paymentSet.chequeName,
        //     value: "2",
        //     tip: this.orderData.paymentSet.chequeCopywriting,
        //     text: this.orderData.paymentSet.chequeAddress
        //   })
        // }

      }
    },
    // 处理上传药品单按钮点击
    handleUploadDrug(orderIndex) {
      // 获取对应索引的订单
      const drugOrder = this.orderData.splitOrders[orderIndex];
      if (drugOrder && drugOrder.isYp) {
        // 根据状态显示弹窗（传入状态、已有图片、拒绝原因、订单号和是否为临时订单）
        this.$refs.uploadDrugDialogRef.showDialog(
          drugOrder.ypCheckStatus,
          drugOrder.ypImages || [],
          drugOrder.orderNo || this.orderData.orderNo,
          true // 在下单页面，是临时订单
        );
        
        // 存储当前操作的订单索引
        this.currentYpOrderIndex = orderIndex;
      }
    },
    
    // 处理药品单上传提交
    handleDrugUploadSubmit() {
      // 更新药品订单详情
      this.getOrderDetail();
    },
    // goToYpOrderList() {
    //   // 跳转到药品单列表
    //   this.$router.push({
    //     path: '/order/orderList',
    //     query: {
    //       isYp: true
    //     }
    //   });
    // },
    // 检查订单中是否包含药品商品
    hasYpProducts() {
      if (!this.orderData || !this.orderData.splitOrders) return false;
      return this.orderData.splitOrders.some(order => order.isYp === true);
    },
    
    // 检查药品状态并返回状态信息
    checkYpUploadStatus() {
      if (!this.hasYpProducts()) return { hasYp: false };
      
      const ypOrders = this.orderData.splitOrders.filter(order => order.isYp === true);
      const hasUploaded = ypOrders.every(order => order.ypCheckStatus !== 0);
      
      return {
        hasYp: true,
        hasUploaded: hasUploaded
      };
    },
    
    // 显示药品提示并在确认后执行下单操作
    showYpTipsAndOrder() {
      const ypStatus = this.checkYpUploadStatus();
      
      if (!ypStatus.hasYp) {
        // 没有药品商品，直接下单
        this.processOrder();
        return;
      }
      
      // 根据是否已上传药品单显示不同提示
      let message = '';
      if (ypStatus.hasUploaded) {
        message = this.$t('該筆訂單中包含藥品商品，您已上傳蓋章藥品單，我們會核盡快核對蓋章藥品單和訂單信息，審核通過後進行發貨。');
      } else {
        message = this.$t('該筆訂單中包含藥品商品，您還未上傳蓋章藥品單，也可在下單成功後在訂單詳情頁進行上傳。');
      }
      
      // 显示提示并在用户确认后执行下单
      this.$refs.drugTipsDialogRef.showDrugTips(message, () => {
        this.processOrder();
      });
    },
    
    // 处理实际下单逻辑
    async processOrder() {
      const toast1 = this.$toast({
        message: this.$t("正在查詢訂單狀態"),
        duration: 0,
        forbidClick: true
      })
      let storeExpress = this.orderData.splitOrders?.map((item, index) => {
        let express = item.expressPrice.find(i => i.isDefault)
        return {
          storeId: item.storeId,
          expressId: express && express.expressId
        }
      })
      let obj = {
        isFromShoppingCart: false, //是否购物车
        storeExpress: storeExpress,
        remark: this.remark,
        couponId: this.couponId,
        isRemittance: this.selectPhone == "1"
      }
      const res = await getCreateOrder2(obj)
      if (res.resultID === 1200) {
        const resData = await pollOrderStatus({ id: res.data })

        if (
          resData.resultID === 1200 &&
          resData.data &&
          resData.data.isSuccess
        ) {
          toast1.close()
          if (this.selectPhone == "0") {
            this.$router.push(`/pay/${res.data}`)
          } else if (this.selectPhone == "1") {
            this.$router.push(
              `/payResult?type=success&payType=52&orderId=${res.data
              }&price=${this.totalPrice}&html=${encodeURI(this.orderData.paymentSet.pubTransferAccount)
              }&tips=${encodeURI(this.orderData.paymentSet.pubTransferCopywriting)}`
            )
          }
        } else {
          this.$toast(resData.data.message || resData.message)
        }
      } else {
        toast1.close()
        this.$toast(res.message)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.order-content {
  padding-bottom: 80px;
}

.adderss {
  color: #3491fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 26px;
  background-color: #fff;
  border-radius: 0px 0px 16px 16px;
  margin-bottom: 12px;

  img {
    width: 20px;
  }

  .address-detail {
    width: 100%;
    padding: 12px;
    background: #f8f8f8;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .address-street {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      color: #1a1a1a;
    }

    .address-city {
      margin-top: 2px;
      font-weight: 500;
      font-size: 13px;
      color: #666666;
    }

    .arrow {
      height: 16px;
      width: 16px;
      margin-left: 11px;
    }

    .top {
      display: flex;
      align-items: center;

      font-weight: 500;
      font-size: 16px;
      color: #1a1a1a;
      margin-bottom: 2px;

      .address-name {
        margin-right: 12px;
      }
    }
  }
}

.pay-type {
  padding: 16px;
  background-color: #fff;
  padding-bottom: 0px;
  border-radius: 16px;
  margin-bottom: 12px;

  .pay-title {
    font-weight: 500;
    font-size: 16px;
    color: #1a1a1a;
    line-height: 24px;
  }

  .phone-list {
    padding: 16px;

    .actvie {
      border: 1px solid #90d12e !important;
    }

    .phone-tip {
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #e4e6e7;
      padding: 16px;
      margin-bottom: 8px;
    }

    .copywritingimg {
      margin-right: 2px;
    }

    .copy-writing {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 8px;
      background: #f6fbee;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #d2edab;
      color: #90d12e;
      margin-top: 12px;

      img {
        width: 16px;
        height: 16px;
      }
    }

    .phone-title {
      color: #f82207;
      font-size: 12px;
      margin-bottom: 12px;
    }

    .phone-item {
      padding: 12px 16px;
      position: relative;
      background: #f8f8f8;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 12px;
      border: 1px solid transparent;
      margin-right: 12px;

      .disable-text {
        font-size: 16px;
        color: #999999;
        line-height: 16px;
        text-align: center;
        word-break: break-word;
        max-width: 100%;
      }

      .phone-text {
        font-size: 16px;
        color: #1a1a1a;
        line-height: 16px;
        text-align: center;
        word-break: break-word;
        max-width: 100%;
      }


      .phone-check {
        position: absolute;
        width: 12px;
        bottom: -1px;
        right: -1px;
      }
    }

    .tigs-red {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #F82207;
      line-height: 22px;
      text-align: left;
    }
  }
}

.Stash {
  background-color: #fff;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  padding-top: 0;

  .Stash-title {
    font-weight: 500;
    font-size: 16px;
    color: #1a1a1a;
    padding-top: 16px;
  }

  .goods-item {
    margin-top: 16px;
    display: flex;

    .goods-img {
      position: relative;

      .tags {
        width: 32px;
        height: 20px;
        text-align: center;
        background: #E84935;
        border-radius: 1px 8px 1px 10px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #FFFFFF;
        line-height: 20px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    img {
      width: 120px;
      height: 120px;
    }

    .goods-info {
      margin-left: 16px;
      position: relative;

      .goods-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        width: 207px;
        font-size: 13px;
        color: #1a1a1a;
      }

      .goods-tag {
        display: inline-block;
        padding: 0 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 11px;
        color: #E84935;
        line-height: 16px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid rgba(232, 47, 47, 0.5);
      }

      .goods-unit {
        font-size: 12px;
        color: #999999;
        margin-top: 4px;
      }

      .goods-price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        width: 100%;

        .price {
          font-weight: 800;
          font-size: 16px;
          color: #f82207;
        }
      }
    }
  }

  .viewall {
    font-weight: 400;
    font-size: 15px;
    color: #3491fa;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    img {
      width: 16px;
      height: 16px;
      margin-left: 4px;
    }
  }

  .Distribution-mode {
    border-bottom: 1px solid #f8f8f8;
    padding-bottom: 16px;

    .Distribution-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16px;
    }

    .label {
      font-size: 15px;
      color: #666666;
    }

    .freight {
      font-weight: 500;
      font-size: 15px;
      color: #f82207;
    }


  }
}

.leaveMessage {
  background-color: #fff;
  padding: 0 16px;
  padding-bottom: 20px;

  .leaveMessage-title {
    margin-bottom: 16px;
  }

  .leaveMessage-inp {
    padding-bottom: 16px;
    border-bottom: 1px solid #f8f8f8;

    input {
      width: 100%;
      background-color: #f8f8f8;
      border-radius: 6px;
      height: 40px;
      padding-left: 12px;
    }
  }

  .aggregate {
    margin: 16px 0;
  }

  .aggregate-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .discountsprice {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #f82207;

      img {
        width: 16px;
      }
    }
  }
}

.order-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  padding: 16px 0px;

  .shop-coudan {
    padding: 0 16px;
    height: 46px;
    background: #FFEBE9;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .shop-coudan-left {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .shop-coudan-right {
      font-weight: 500;
      font-size: 12px;
      color: #666666;
      line-height: 18px
    }

    .tags {
      padding: 4px 8px;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 11px;
      color: #FFFFFF;
      background: linear-gradient(300deg, #FF7B31 0%, #F9151E 100%), #FF7A00;
      border-radius: 4px 4px 4px 4px;
    }

    .EnTigs {
      font-weight: 500;
      font-size: 12px;
      color: #1A1A1A;
      line-height: 20px;

      span {
        font-weight: 500;
        font-size: 12px;
        color: #E84935;
        line-height: 20px;
      }
    }

    .tigs {
      font-weight: 500;
      font-size: 13px;
      color: #1A1A1A;
      line-height: 20px;
      margin-left: 6px;

      span {
        font-weight: 500;
        font-size: 13px;
        color: #E84935;
        line-height: 20px;
      }
    }
  }

  .price {
    margin-left: 16px;
    font-weight: 800;
    font-size: 20px;
    color: #f82207;
  }

  .Placeorder {
    padding: 10px 45px;
    background: #90d12e;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    margin-right: 16px;
  }
}

.upload-btn {
  color: #262626;
  cursor: pointer;
}
.upload-red {
  color: #F12809;
}

.view-yp-list {
  color: #90D12E;
  font-size: 14px;
  cursor: pointer;
}
</style>
